import { DOCUMENT_TYPES } from 'constants/documents';

export const VALID_DOCUMENT_TYPES_FOR_IMAGE_CONTENT = [
    DOCUMENT_TYPES.DNI_FRONT,
    DOCUMENT_TYPES.DNI_BACK,
    DOCUMENT_TYPES.NIE_FRONT,
    DOCUMENT_TYPES.PASSPORT_FRONT,
    DOCUMENT_TYPES.PASSPORT_BACK,
    DOCUMENT_TYPES.PERMIT_FRONT,
    DOCUMENT_TYPES.PERMIT_BACK,
];

export const VALID_DOCUMENT_TYPES_FOR_ACCEPTED_DOCUMENTS_CONTENT = [
    DOCUMENT_TYPES.DAAL,
    DOCUMENT_TYPES.RECIBO_TRANSFERENCIA,
    DOCUMENT_TYPES.TRANSFER_CERTIFICATE,
];

export const TGSS_RADIO_VALUES = {
    CONSENT: 'consent',
    UPLOAD: 'upload',
};
